/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface FindResources$Params {

/**
 * If not provided, only ACTIVE resources will be returned
 */
  withInactive?: boolean;

/**
 * If not provided, only VISIBLE resources will be returned
 */
  withInvisible?: boolean;
  bookId?: string;
  resourceType?: 'TIME' | 'PERSONAL' | 'OTHER';
  withDcUserId?: boolean;
}

export function findResources(http: HttpClient, rootUrl: string, params?: FindResources$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Resource>>> {
  const rb = new RequestBuilder(rootUrl, findResources.PATH, 'get');
  if (params) {
    rb.query('withInactive', params.withInactive, {});
    rb.query('withInvisible', params.withInvisible, {});
    rb.query('bookId', params.bookId, {});
    rb.query('resourceType', params.resourceType, {});
    rb.query('withDcUserId', params.withDcUserId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Resource>>;
    })
  );
}

findResources.PATH = '/api/agn-resources';
